module.exports = "/_next/static/images/bfd39a5802a67bf130cad4d444c03103-nubanker-xpeer@1x.jpg";